<template>
  <el-select
     ref="select"
     v-model="value"
     class="select-filter"
     :multiple="true"
     :placeholder="placeholder"
     :clearable="true"
     :filterable="true"
     :loading="loader"
     :remote-method="loadSegment"
     :remote="true"
     :disabled="disabled"
     :multiple-limit="1"
     value-key="uniqueName"
     @change="handleChange">
    <el-option
       v-for="v in segment"
       :key="v.uniqueName"
       :label="v.caption"
       :value="v" />
  </el-select>
</template>

<script>
import SelectFilter from './SelectFilter.vue'

export default {
  extends: SelectFilter,
  methods: {
    setValues (values, clearDefault) {
      if (!values) {
        return Promise.resolve()
      }
      values = JSON.parse(JSON.stringify(values))
      this.clearDefault = clearDefault || true
      return this.load().then(() => {
        if (values && values.length) {
          values.splice(1, values.length)
          this.segment.splice(0, 0, ...values.filter(v => {
            return this.segment.findIndex(s => s.uniqueName === v.uniqueName) === -1
          }))
          this.value.splice(0, this.value.length, ...values)
        } else {
          this.value.splice(0)
        }
        this.$emit('change', {
          dimension: this.api.dimension.uniqueName(this.data.value),
          values: values
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/filter/SingleSelectFilter.vue